import { screens } from '~/theme';
import { useWindowSize } from '~/hooks';

export default function useBreakpoint() {
  const size = useWindowSize();
  const mdScreenSize = Number(screens['md'].replace('px', ''));
  const lgScreenSize = Number(screens['lg'].replace('px', ''));
  const xlScreenSize = Number(screens['xl'].replace('px', ''));
  const xxlScreenSize = Number(screens['2xl'].replace('px', ''));
  const hdScreenSize = Number(screens['3xl'].replace('px', ''));

  const mobileScreen = size.width <= mdScreenSize;
  const mdScreen = size.width <= lgScreenSize;
  const lgScreen = size.width <= xlScreenSize;
  const xlScreen = size.width <= xxlScreenSize;
  const xxlScreen = size.width <= hdScreenSize;

  return {
    mobileScreen,
    mdScreen,
    lgScreen,
    xlScreen,
    xxlScreen,
  };
}
